import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // Genel stil dosyasını içe aktar
import './styles/animations.css'; // Animation styles
import { BrowserRouter } from 'react-router-dom'; // BrowserRouter'ı içe aktar
import { initApi } from './api'; // Import the initApi function

// Initialize the API - will use runtime config if available
initApi();

const container = document.getElementById('root');
if (container) {
    const root = ReactDOM.createRoot(container);
    root.render(
        // <React.StrictMode> {/* Temporarily removed for dnd debugging */}
            <BrowserRouter> {/* BrowserRouter ile sarmala */}
                <App />
            </BrowserRouter>
        // </React.StrictMode>
    );
} else {
    console.error('Root element not found');
}